import { React, Route, Routes, ui, useLocation, useNavigate } from '_core';

import NotFound from '_components/404';

import EmbeddedWidget from '../views/report/embedded-widget';

const Global = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Function to update the URL with only the random query parameter to invalidate the cache
  const invalidateCache = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const randomQueryParam = `${Math.random().toString(36).substring(7)}`;

    urlParams.set('cache', randomQueryParam);

    // Remove existing query parameters, if any
    const pathname = location.pathname;
    const search = `?${urlParams.toString()}`;

    navigate(`${pathname}${search}`);
  };

  React.useEffect(() => {
    invalidateCache();
  }, []);

  return (
    <Routes>
      <Route path="embedded/:widget_key">
        <Route
          index
          path={'*'}
          element={
            <ui.RenderByRouteParam
              component={({ widget_key }: { widget_key: string }) => <EmbeddedWidget widgetKey={widget_key} />}
            />
          }
        />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Global;
